import {ActionMenu, ActionList} from '@primer/react'
import {useSubAgents} from '../hooks/useSubAgents'

interface Repository {
  owner: string
  nameOnly: string
}

export function SubAgentSelector({
  apiURL,
  selectedAgent,
  onSelect,
  selectedRepo,
}: {
  apiURL?: string | null
  selectedAgent: string | null
  onSelect: (agent: string) => void
  selectedRepo: Repository | null
}) {
  const owner = selectedRepo?.owner || null
  const repo = selectedRepo?.nameOnly || null
  const {data: agents, isLoading} = useSubAgents({apiURL, owner, repo})

  if (!selectedRepo) {
    return null
  }

  let selectedLabel = 'Subagent'
  if (selectedAgent) {
    selectedLabel = `Subagent: ${selectedAgent.charAt(0).toUpperCase()}${selectedAgent.slice(1)}`
  }

  return (
    <ActionMenu>
      <ActionMenu.Button>{selectedLabel}</ActionMenu.Button>
      <ActionMenu.Overlay width="medium">
        <ActionList selectionVariant="single">
          {isLoading ? (
            <ActionList.Item>Loading subagents...</ActionList.Item>
          ) : !agents || agents.length === 0 ? (
            <ActionList.Item>No subagents available</ActionList.Item>
          ) : (
            agents.map(agent => (
              <ActionList.Item
                key={agent.name}
                selected={selectedAgent === agent.name}
                onSelect={() => onSelect(agent.name)}
              >
                {agent.name.charAt(0).toUpperCase() + agent.name.slice(1)}
              </ActionList.Item>
            ))
          )}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ SubAgentSelector.displayName ||= 'SubAgentSelector' } catch {}